module.exports = __webpack_public_path__ + "assets/img/1.3ea9e713.png";